(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product_tabs"] && !Shopify.designMode) return;
  try {
    (function () {
  function bindProductAccordions(scope) {
    scope.querySelectorAll('.t4s-product-tabs-wrapper [data-t4s-accordion-pr]').forEach(function (tabs) {
      if (tabs.hasAttribute('data-mc-animation-ready')) return;
      tabs.setAttribute('data-mc-animation-ready', '');
      tabs.addEventListener('click', function (event) {
        var title = event.target.closest('[data-t4s-tab-wrapper] > [data-t4s-tab-item]');
        if (!title || title.closest('[data-t4s-accordion-pr]') !== tabs) return;
        var jquery = window.jQuery_T4NT;
        if (!jquery) return;
        tabs.querySelectorAll('[data-t4s-tab-content]').forEach(function (panel) {
          if (panel.closest('[data-t4s-accordion-pr]') === tabs) {
            jquery(panel).stop(true, true);
          }
        });
      }, true);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindProductAccordions(document);
    }, { once: true });
  } else {
    bindProductAccordions(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    bindProductAccordions(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
